export const useMediaProtection = () => {
  function contextmenuHandler(event: PointerEvent) {
    event.preventDefault();
  }

  function dragHandler(event: DragEvent) {
    event.preventDefault();
  }

  function VisibiltyChangeHandler() {
    document.body.style.filter = document.hidden ? "blur(12px)" : "none";
  }

  onMounted(() => {
    document.addEventListener("contextmenu", contextmenuHandler);
    document.addEventListener("dragstart", dragHandler);
    document.addEventListener("visibilitychange", VisibiltyChangeHandler);
  });

  onUnmounted(() => {
    document.removeEventListener("contextmenu", contextmenuHandler);
    document.removeEventListener("dragstart", dragHandler);
    document.removeEventListener("visibilitychange", VisibiltyChangeHandler);
  });
};
